export const OFFBOOK_ADVANCE_TILE_PART_1 = 'Ownership and servicing of your';
export const OFFBOOK_ADVANCE_TILE_PART_2 = '2021 WebBank PPP loan was transferred to Customers Bank on 9/17/2021.';

export const OFFBOOK_ADVANCE_SUBTEXT_PART_1 = 'Loan servicing and repayment for your 2021 PPP loan will be managed by Customers Bank, through its servicing partner Windsor Advantage. You can contact Windsor Advantage by email at ';
export const OFFBOOK_ADVANCE_SUBTEXT_EMAIL = 'PPServicing@Windsoradvantage.com';
export const OFFBOOK_ADVANCE_SUBTEXT_PART_2 = ' or by phone at ';
export const OFFBOOK_ADVANCE_SUBTEXT_PHONE = '1-312-585-7666';
export const OFFBOOK_ADVANCE_SUBTEXT_PART_3 = ' Monday through Friday 8 a.m. to 5 p.m. ET.';
